module.exports = __webpack_public_path__ + "img/voltaje_c_red.e617da59.svg";